<template>
  <delete-button @click="removeBubble"/>
</template>

<script>
import chatBubbleModule from '@/store/modules/chat-bubble.module'
import DeleteButton from '../DeleteButton'
import templateModule from '@/store/modules/template.module'
import templateController from '@/controllers/template.controller'
import answerController from '@/controllers/answer.controller'
import stateTreeUtils from '@/utils/state-tree.utils'

export default {
  name: 'DeleteMessageButton',

  components: {
    DeleteButton
  },

  props: {
    botId: {
      type: String,
      required: true
    }
  },

  computed: {
    bubbleSelected: chatBubbleModule.bubbleSelected,
    stateTree: chatBubbleModule.stateTree,

    answerStateId() {
      return this.$store.state.answer.stateId
    },

    previewController() {
      return templateModule.isTemplateEditor() ? templateController : answerController
    }
  },

  methods: {
    removeBubble() {
      const node = stateTreeUtils.findNode(this.stateTree, this.bubbleSelected)
      this.previewController.removeBubble(node, templateModule.getTemplateId())
    }
  }
}
</script>
